import { render, staticRenderFns } from "./VirtualOffice.vue?vue&type=template&id=a8a723c4&scoped=true&"
import script from "./VirtualOffice.vue?vue&type=script&lang=js&"
export * from "./VirtualOffice.vue?vue&type=script&lang=js&"
import style0 from "./VirtualOffice.vue?vue&type=style&index=0&id=a8a723c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a723c4",
  null
  
)

export default component.exports